// extracted by mini-css-extract-plugin
export var sliderRange = "_mu-2";
export var sliderRoot = "_mu-0";
export var sliderThumb = "_mu-3";
export var sliderTrack = "_mu-1";